import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const LayoutContent = styled.div`
  padding: 30px 24px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 3px 10px ${(props) => props.theme["@box-shadow"]};
`;

export const CardContent = styled.div`
  display: grid;
  grid-template-rows: 30px auto;
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-rows: 20px 1px;
  gap: 10px;
  .divider {
    background-color: ${(props) => props.theme["@input-border-color"]};
    height: 1px;
  }
`;

export const ScrollWrapperContainer = styled.div`
  position: relative;
`;

export const CollapseIcon = styled.div`
  position: absolute;
  top: -12px;
  right: 0;
  cursor: pointer;
  font-size: 16px;
  color: #999;
`;

export const ScrollWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  min-height: ${(props) => (props.hasSchedule && props.hasLenghtOfStay ? "200px" : (props.hasSchedule || props.hasLenghtOfStay) && "180px")};
`;

export const ArrowButton = styled.button<{ left?: boolean }>`
  position: absolute;
  top: 50%;
  ${(props) => (props.left ? "left: 0;" : "right: 0;")}
  transform: translateY(-50%);
  z-index: 1;
  border: none;
  box-shadow: none;
  color: #d9d9d9;
  padding: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
  background: transparent;
  margin: 0 -12px;
  &:hover {
    opacity: 0.9;
    color: #000;
  }
`;

export const ItemsContainer = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  max-width: 100%;
  margin: 0px 25px 0 25px;
  min-height: ${(props) => (props.hasSchedule && props.hasLenghtOfStay ? "200px" : (props.hasSchedule || props.hasLenghtOfStay) && "180px")};
`;

export const HeaderDescription = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .collapse-icon {
    cursor: pointer;
  }
  .vehicleInfoDescription {
    border-radius: 300px;
    font-size: 10px;
    font-weight: 500;
    width: 50px;
    height: 25px;
    align-items: center;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    align-content: center;
  }
`;

export const CardTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
`;

export const TotalLengthOfStay = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`;

export const TruckContainer = styled.div`
  display: grid;
  grid-template-rows: 85px 15% 15%;
  gap: 5px;
  margin-top: 15px;
  width: 175px;
`;

export const TruckButton = styled.button`
  position: relative;
  width: 173px;
  height: 80px;
  justify-items: end;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`;

export const InfoTags = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.hasSaleChannel ? "auto auto" : "50%")};
  ${(props) => !props.hasSaleChannel && "justify-content: center"};
  gap: 5px;
  .vehicleInfo {
    width: 100%;
    text-align: center;
    border-radius: 300px;
    font-size: 10px;
    font-weight: 600;
    align-content: center;
  }
`;

export const InfoData = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

export const LengthOfStayData = styled.div`
  display: grid;
  grid-template-columns: auto;
  align-items: center;
  justify-content: center;
`;

export const DataDescription = styled.h1`
  font-size: 12px;
  display: grid;
  margin: 0;
  grid-template-columns: auto;
`;

export const LoadingContainer: CSSProperties = {
  width: "100%",
  minHeight: "100%",
  height: "-webkit-fill-available",
  alignItems: "center",
  justifyContent: "center",
  display: "grid",
};

export const ReleasedIcon: CSSProperties = {
  position: "absolute",
  top: 4,
  left: 0,
  fontSize: 16,
  color: "#fff",
  borderRadius: "50%",
  border: 0,
  display: "flex",
  padding: 0,
  alignItems: "center",
  justifyContent: "center",
};

export const TagNotLinkedIcon: CSSProperties = {
  position: "absolute",
  top: 38,
  left: 0,
  fontSize: 16,
  color: "#fff",
  borderRadius: "50%",
  border: 0,
  display: "flex",
  padding: 0,
  alignItems: "center",
  justifyContent: "center",
};

export const ShippingTruckIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
};

export const Label = styled.span`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  margin-bottom: 8px !important;
`;

export const SelectField: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};
